/* eslint-disable indent */
import { html, css } from 'lit-element';
import { BaseElement } from './BaseElement';
import logo from '../../img/logo.png';
import { API, LOGIN_STATUSES, EVENT_TYPES } from '../API';
import { Account } from '../Account';

import './QuickLogin';
import './AccountDisplay';
import './Connecting';

const _api = Symbol();
const _account = Symbol();
const _apiLoginStatusHandler = Symbol();

export class MainHeader extends BaseElement {
	constructor() {
		super();

		this[_apiLoginStatusHandler] = () => this.requestUpdate();
	}
	static get styles() {
		return [
			...BaseElement.styles,
			css`
				:host {
					display: flex;
					flex-flow: row wrap;
				}
				.logo {
					flex-grow: 0;
				}
				pp-quick-login {
					flex-grow: 1;
					text-align: right;
				}
				pp-account-display {
					flex-grow: 1;
					text-align: right;
				}
				pp-connecting {
					flex-grow: 1;
					text-align: right;
				}
			`
		];
	}
	get api() {
		return this[_api];
	}
	set api(v) {
		if(!(v instanceof API))
			throw new TypeError('api must be an instance of API.');
		this[_api] = v;
	}
	get account() {
		return this[_account];
	}
	set account(v) {
		if(!(v instanceof Account))
			throw new TypeError('account must be an instance of Account.');
		this[_account] = v;
	}
	connectedCallback() {
		super.connectedCallback();

		this.emit('get-api', { callback: api => this.api = api });

		this.api.on(EVENT_TYPES.EVENT_TYPE_LOGIN_STATUS, this[_apiLoginStatusHandler]);
	}
	disconnectedCallback() {
		super.disconnectedCallback();

		this.api.off(null, this[_apiLoginStatusHandler]);
	}
	render() {
		const working = [
			LOGIN_STATUSES.LOGIN_STATUS_LOGGING_IN,
			LOGIN_STATUSES.LOGIN_STATUS_REFRESHING
		].indexOf(this.api.loginStatus) !== -1;
		
		return html`
			<div class="logo">
				<img src="${logo}" />
			</div>
			<pp-connecting class="${working ? '' : 'no-display'}"></pp-connecting>
			<pp-account-display class="no-print ${this.api.loginStatus === LOGIN_STATUSES.LOGIN_STATUS_LOGGED_IN ? '' : 'no-display'}"></pp-account-display>
			<pp-quick-login class="no-print ${this.api.loginStatus === LOGIN_STATUSES.LOGIN_STATUS_LOGGED_OUT ? '' : 'no-display'}"></pp-quick-login>
		`;
	}
}

customElements.define('pp-main-header', MainHeader);